import { IncrementalSearchResponseData } from 'generated/graphql'
import { useIncrementalSearchV2 } from 'hooks/search/useIncrementalSearchV2'
import { useCallback, useEffect, useState } from 'react'

const limit = 10
const delayMilliseconds = 300

export const useSearchHotelForm = () => {
  const incrementalSearchState = useIncrementalSearchV2({ limit, delayMilliseconds })
  const [data, setData] = useState<IncrementalSearchResponseData[]>([])

  const incrementalSearch = useCallback(
    (keyword: string) => {
      incrementalSearchState.search(keyword)
    },
    [incrementalSearchState.search]
  )

  const resetState = useCallback(() => {
    setData([])
  }, [setData])

  useEffect(() => {
    setData(incrementalSearchState.searchResult?.data ?? [])
  }, [incrementalSearchState.searchResult])

  return {
    incrementalSearch,
    resetState,
    data,
    loading: incrementalSearchState.loading,
    error: incrementalSearchState.error,
  }
}
